export function blobToArrayBuffer(blob:Blob):Promise<ArrayBuffer> {


    if('arrayBuffer' in blob && typeof blob.arrayBuffer === 'function') {
        return blob.arrayBuffer();
    }

	const fileReader = new FileReader();

	return new Promise(function(resolve, reject) {
		fileReader.onload = function(d) {
            resolve(d.target!.result as ArrayBuffer);
        };
		fileReader.onerror = reject;

		fileReader.readAsArrayBuffer(blob);
	});
};
